<template>
  <div class="py-4 bg-secondary">
    <div class="profile-page">
      <section class="section-new">
        <div class="container">
          <el-row>
            <el-col :span="24">
              <div class="card card-lift shadow border-0 card-address_page mb-3">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                  <el-breadcrumb-item :to="{ path: '/' }">{{ $t('menu.main') }}</el-breadcrumb-item>
                  <el-breadcrumb-item :to="{ path: '/savol-javob' }">{{ $t('menu.savoljavob') }}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{ $t('menu.savoljavob') }}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
      <section class="section py-3" >

        <div class="container">
          <div class="tab_div_top">
          <card shadow class="card-profile mt--100 card_radius_no" no-body style="z-index: 10; position: relative">
            <div class="user_name_and_date">
              <h6 style="font-weight: bold;">{{ moment(answerToQuestion.createdDate).format('DD.MM.YYYY') }}</h6>
              <span style="font-size: 12px; display:flex;">Савол юборувчи шахс: &nbsp<h6 style="font-weight: bold;">{{ answerToQuestion.senderName }} </h6></span>
            </div>
            <div class="px-4">
              <div class="text-center mt-2">
                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span
                    class="news_title">{{ $t('savol_javob.savol') }}</span>
                  <p class="question">{{ answerToQuestion.question }}</p></div>
              </div>
              <div class="mt-3 py-3 border-top text-center">
                <div class="row justify-content-center">
                  <div class="col-lg-12">
                    <span
                        class="news_title">{{ $t('savol_javob.javob') }}</span>
                    <div v-html="answerToQuestion.answer"></div>
                  </div>
                </div>
              </div>
            </div>
          </card>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      answerToQuestion: []
    };
  },
  mounted() {
    axios.get(`https://www.prokuratura.uz/api/blogs-for-web-site/${this.$route.params.id}`)
        .then(response => {
          this.answerToQuestion = response.data
        })
  }
}
</script>
<style scoped>

.tab_div_top {
  min-height: 600px;
  margin-top: 15px;
}

.question {
text-align: center;
}

.user_name_and_date {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 20px;
}

</style>

